import * as u from "react";
function c(n, e, t) {
  var r = u.useRef({});
  return (!("value" in r.current) || t(r.current.condition, e)) && (r.current.value = n(), r.current.condition = e), r.current.value;
}
export {
  c as default
};
//# sourceMappingURL=useMemo.mjs.map
